import React from 'react';

const ProjectsComponent = () => {

return (

<div className="container">

    <h3>My Project</h3>

   

    <div id="carouselExampleControls" className="carousel slide" data-ride="carousel">
        <div className="carousel-inner">
          
           <div className="carousel-item active">
               <a href="https://fatinabila.github.io/covid19-dashboard/" target="_blank" rel="noopener noreferrer"> 
                <img src="img/covid19-preview-1.png" className="d-block w-100" alt="..."/>
               </a>
            </div>
					
					 {/* <div className="carousel-item active">
                       <a href="https://fatinabila.github.io/covid19-dashboard/" target="_blank" rel="noopener noreferrer"> 
                         <img src="img/ip-address-preview.png" className="d-block w-100" alt="..."/>
                       </a>
                    </div> */}
        </div>
        <a className="carousel-control-prev" href="#carouselExampleControls" role="button" data-slide="prev">
            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
            <span className="sr-only">Previous</span>
        </a>
        <a className="carousel-control-next" href="#carouselExampleControls" role="button" data-slide="next">
            <span className="carousel-control-next-icon" aria-hidden="true"></span>
            <span className="sr-only">Next</span>
        </a>
    </div>




</div>

)
}

export default ProjectsComponent